import { render } from "./PlotDetailsModal.vue?vue&type=template&id=1fdd04e2"
import script from "./PlotDetailsModal.vue?vue&type=script&lang=js"
export * from "./PlotDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__